import ChatMessageForm from './ChatMessageForm';

export default ChatMessageForm;
